import { render, staticRenderFns } from "./ExampleScoring.vue?vue&type=template&id=482ee603&"
import script from "./ExampleScoring.vue?vue&type=script&lang=js&"
export * from "./ExampleScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports